type StoneImageLot = {
  title?: string;
  material?: string;
  origin?: string;
  color_family?: string;
  colors?: string;
  type?: string;
  images_json?: string;
};

const REAL_STONE_IMAGES: Record<string, string[]> = {
  carrara: [
    'https://mmgmarble.com/wp-content/uploads/2023/02/bianco-carrara.jpg',
    'https://terrastone.gallery/wp-content/uploads/2023/02/Thassos.jpg',
  ],
  statuario: [
    'https://elegantmarbles.com/cdn/shop/products/imported-marble-statuario-extra-elegant-marbles-ltd-31821588496539_1800x1800.jpg?v=1627982366',
    'https://images.unsplash.com/photo-1566041510394-cf7c8fe21800?w=1000&q=82&auto=format&fit=crop',
  ],
  calacatta: [
    'https://www.bordignonstone.com/cdn/shop/products/CalacattaBorghiniSlab_78.png?v=1675192462&width=1200',
    'https://images.unsplash.com/photo-1615971677499-5467cbab01c0?w=1000&q=82&auto=format&fit=crop',
  ],
  arabescato: [
    'https://mqmarble.com/wp-content/uploads/2024/07/Arabescato-Corchia-White-Marble-Slab.webp',
    'https://mqmarble.com/wp-content/uploads/2024/07/Arabescato-Corchia-Marble-Polished-Slab.webp',
  ],
  bardiglio: [
    'https://images.prismic.io/nascostonetile/aLiks2GNHVfTOmoR_BardiglioMarbleSlabs2CMLot1.jpg?auto=format%2Ccompress&h=1510&q=80&rect=0%2C0%2C2000%2C1510&w=1200',
    'https://images.unsplash.com/photo-1541123603104-512919d6a96c?w=1000&q=82&auto=format&fit=crop',
  ],
  neroMarquina: [
    'https://crofthouse.com/cdn/shop/products/Nero_1946x.jpg?v=1671213938',
    'https://images.unsplash.com/photo-1551009175-15bdf9dcb580?w=1000&q=82&auto=format&fit=crop',
  ],
  afyon: [
    'https://mmgmarble.com/wp-content/uploads/2021/05/volakas-white-marble.jpg',
    'https://terrastone.gallery/wp-content/uploads/2023/02/Thassos.jpg',
  ],
  emperador: [
    'https://www.rlautier.com/cdn/shop/products/emperadordarkslab_250x.jpg?v=1591265596',
    'https://images.unsplash.com/photo-1585314062340-f1a5a7c9328d?w=1000&q=82&auto=format&fit=crop',
  ],
  cremaMarfil: [
    'https://abcworldwidestone.com/wp-content/uploads/2018/03/Crema-Marfil-Polished-2cm-Lot-B3216-Slab-39-Close-Up.jpg',
    'https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1000&q=82&auto=format&fit=crop',
  ],
  thassos: [
    'https://terrastone.gallery/wp-content/uploads/2023/02/Thassos.jpg',
    'https://mmgmarble.com/wp-content/uploads/2021/05/volakas-white-marble.jpg',
  ],
  volakas: [
    'https://mmgmarble.com/wp-content/uploads/2021/05/volakas-white-marble.jpg',
    'https://mmgmarble.com/wp-content/uploads/2021/04/Volakas-White-Marble-2cm-1.jpg',
  ],
  makrana: [
    'https://terrastone.gallery/wp-content/uploads/2023/02/Thassos.jpg',
    'https://mmgmarble.com/wp-content/uploads/2021/05/volakas-white-marble.jpg',
  ],
  fantasyBrown: [
    'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1000&q=82&auto=format&fit=crop',
    'https://www.rlautier.com/cdn/shop/products/emperadordarkslab_250x.jpg?v=1591265596',
  ],
  azulBahia: [
    'https://www.eonyx.com/wp-content/uploads/2022/04/Azul-Bahia-Granite-Slabs.jpg',
    'https://images.unsplash.com/photo-1567095761054-7a02e69e5c43?w=1000&q=82&auto=format&fit=crop',
  ],
  tajMahal: [
    'https://images.unsplash.com/photo-1533282960533-51328aa49826?w=1000&q=82&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1000&q=82&auto=format&fit=crop',
  ],
  verdeUbatuba: [
    'https://www.eonyx.com/wp-content/uploads/2022/03/Verde-Ubatuba-Granite-Slabs.jpg',
    'https://images.unsplash.com/photo-1504274066651-8d31a536b11a?w=1000&q=82&auto=format&fit=crop',
  ],
  green: [
    'https://www.eonyx.com/wp-content/uploads/2022/03/Verde-Ubatuba-Granite-Slabs.jpg',
    'https://images.unsplash.com/photo-1504274066651-8d31a536b11a?w=1000&q=82&auto=format&fit=crop',
  ],
  grey: [
    'https://images.prismic.io/nascostonetile/aLiks2GNHVfTOmoR_BardiglioMarbleSlabs2CMLot1.jpg?auto=format%2Ccompress&h=1510&q=80&rect=0%2C0%2C2000%2C1510&w=1200',
    'https://images.unsplash.com/photo-1541123603104-512919d6a96c?w=1000&q=82&auto=format&fit=crop',
  ],
  black: [
    'https://crofthouse.com/cdn/shop/products/Nero_1946x.jpg?v=1671213938',
    'https://images.unsplash.com/photo-1551009175-15bdf9dcb580?w=1000&q=82&auto=format&fit=crop',
  ],
  beige: [
    'https://abcworldwidestone.com/wp-content/uploads/2018/03/Crema-Marfil-Polished-2cm-Lot-B3216-Slab-39-Close-Up.jpg',
    'https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1000&q=82&auto=format&fit=crop',
  ],
  brown: [
    'https://www.rlautier.com/cdn/shop/products/emperadordarkslab_250x.jpg?v=1591265596',
    'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1000&q=82&auto=format&fit=crop',
  ],
  blue: [
    'https://www.eonyx.com/wp-content/uploads/2022/04/Azul-Bahia-Granite-Slabs.jpg',
    'https://images.unsplash.com/photo-1567095761054-7a02e69e5c43?w=1000&q=82&auto=format&fit=crop',
  ],
  red: [
    'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1000&q=82&auto=format&fit=crop',
    'https://www.rlautier.com/cdn/shop/products/emperadordarkslab_250x.jpg?v=1591265596',
  ],
  white: [
    'https://mmgmarble.com/wp-content/uploads/2023/02/bianco-carrara.jpg',
    'https://terrastone.gallery/wp-content/uploads/2023/02/Thassos.jpg',
  ],
};

const BLOCK_CONTEXT_IMAGES = [
  'https://mmgmarble.com/wp-content/uploads/2021/04/Volakas-White-Marble-2cm-1.jpg',
  'https://terrastone.gallery/wp-content/uploads/2023/02/Thassos.jpg',
];

function parseImages(imagesJson?: string): string[] {
  try {
    const images = JSON.parse(imagesJson || '[]');
    return Array.isArray(images) ? images.filter((url): url is string => typeof url === 'string' && url.trim().length > 0) : [];
  } catch {
    return [];
  }
}

function parseColors(lot: StoneImageLot): string[] {
  try {
    const colors = JSON.parse(lot.colors || '[]');
    if (Array.isArray(colors)) return colors.map(String);
  } catch {}
  return lot.color_family ? [lot.color_family] : [];
}

function lotText(lot: StoneImageLot): string {
  const text = [
    lot.title,
    lot.material,
    lot.origin,
    lot.color_family,
    ...parseColors(lot),
  ].join(' ').toLowerCase();

  return text;
}

function pickImageKey(lot: StoneImageLot): string {
  const text = lotText(lot);

  if (/(arabescato|corchia)/.test(text)) return 'arabescato';
  if (/(calacatta|borghini|michelangelo|oro)/.test(text)) return 'calacatta';
  if (/(statuario)/.test(text)) return 'statuario';
  if (/(bianco carrara|carrara c|carrara cd|carrara block)/.test(text)) return 'carrara';
  if (/(nero|black|marquina)/.test(text)) return 'neroMarquina';
  if (/(bardiglio)/.test(text)) return 'bardiglio';
  if (/(afyon)/.test(text)) return 'afyon';
  if (/(emperador)/.test(text)) return 'emperador';
  if (/(crema|marfil)/.test(text)) return 'cremaMarfil';
  if (/(thassos)/.test(text)) return 'thassos';
  if (/(volakas)/.test(text)) return 'volakas';
  if (/(makrana)/.test(text)) return 'makrana';
  if (/(fantasy brown)/.test(text)) return 'fantasyBrown';
  if (/(azul|bahia)/.test(text)) return 'azulBahia';
  if (/(taj mahal|quartzite)/.test(text)) return 'tajMahal';
  if (/(verde|ubatuba|indian green|green marble)/.test(text)) return 'verdeUbatuba';
  if (/(nero|black|marquina)/.test(text)) return 'black';
  if (/(bardiglio|grey|gray|silver)/.test(text)) return 'grey';
  if (/(crema|beige|cream|travertine|taj|marfil|limestone)/.test(text)) return 'beige';
  if (/(brown|emperador|bronze)/.test(text)) return 'brown';
  if (/(green|verde|ubatuba)/.test(text)) return 'green';
  if (/(blue|azul|bahia)/.test(text)) return 'blue';
  if (/(red|rosso|pink|orange|gold)/.test(text)) return 'red';
  return 'white';
}

export function isDemoOrLowConfidenceImage(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.hostname.includes('images.unsplash.com') || parsed.hostname.includes('source.unsplash.com');
  } catch {
    return false;
  }
}

function unique(urls: string[]): string[] {
  return [...new Set(urls.filter(Boolean))];
}

export function getStoneFallbackImages(lot: StoneImageLot, limit = 3): string[] {
  const set = REAL_STONE_IMAGES[pickImageKey(lot)] || REAL_STONE_IMAGES.white;
  const context = lot.type === 'block' ? BLOCK_CONTEXT_IMAGES : [];
  return unique([...set, ...context, ...REAL_STONE_IMAGES.white]).slice(0, limit);
}

export function getUploadedLotImages(imagesJson?: string): string[] {
  return parseImages(imagesJson).filter((url) => !isDemoOrLowConfidenceImage(url));
}

export function hasUploadedLotImage(imagesJson?: string): boolean {
  return getUploadedLotImages(imagesJson).length > 0;
}

export function getLotImages(lot: StoneImageLot, limit = 4): string[] {
  const realUploads = getUploadedLotImages(lot.images_json);
  const fallback = getStoneFallbackImages(lot, limit);
  return unique([...realUploads, ...fallback]).slice(0, limit);
}

export function getLotImage(lot: StoneImageLot): string {
  return getLotImages(lot, 1)[0];
}
